import React from 'react';
import {useTranslation} from 'react-i18next';

import type {DeviceManager} from '@/entities/device/types';
import {Banner} from '@/shared/ui/banner';

/**
 * «Управляется десктопом X» (SV-13): the one sentence that explains why the controls a
 * cloud terminal has are missing here. Without it the owner sees a card with fewer
 * buttons and no reason.
 */
export function ManagedByDesktopBanner({manager}: {manager: DeviceManager}) {
  const {t} = useTranslation();
  return (
    <Banner
      tone="info"
      icon="desktop"
      title={
        manager.name
          ? t('home.device.managedBy.title', {name: manager.name})
          : t('home.device.managedBy.titleUnnamed')
      }
      message={t('home.device.managedBy.hint')}
    />
  );
}
